














import { Prop, Component, Vue } from 'vue-property-decorator';

import { RoundInterface } from '@/interfaces/interfaces';

@Component
export default class RoundsFilter extends Vue {
  @Prop()
  public rounds!: RoundInterface[];
  @Prop()
  public changeSelectedRound!: any;

  public selectedRound: RoundInterface | null = null;

  public created() {
    this.selectedRound = this.rounds[0];
  }

  private handleChangeSelectedRound(round: RoundInterface) {
    this.changeSelectedRound(round);
  }
}
